import { Grid } from "@mui/material";
import { action, API, controller } from "api";
import { Input, InputAuto, InputImg } from "controls";
import React, { useEffect, useState } from "react";

const OrgInfo = ({ values, setValues, errors, handleFile, handleInpChg }) => {
  const [taxes, setTaxes] = useState([]);
  const [currs, setCurrs] = useState([]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    API(controller.Tax + action.GetAllByOrg).get((res) => {
      if (res.status === 200)
        setTaxes([...res.result.map((j) => ({ ...j, label: j.name }))]);
    });

    API(controller.Currency + action.GetLabels).get((res) => {
      res?.status === 200 && setCurrs([...res.result]);
    });

    API(controller.Customer + action.GetLabels).get((res) => {
      res?.status === 200 && setCustomers([...res.result]);
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} md={4}>
        <Input
          label="Organization Name"
          name="orgName"
          required={true}
          value={values.orgName}
          error={errors.orgName}
          inputProps={{ maxLength: 200 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputAuto
          required={true}
          label="Currency"
          name="currencyId"
          value={values.currencyId}
          error={errors.currencyId}
          onChange={handleInpChg}
          options={currs}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputAuto
          label="Default sales tax"
          name="defTax"
          value={values.defTax}
          error={errors.defTax}
          onChange={handleInpChg}
          options={taxes}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputAuto
          label="Default Customer"
          name="defaultCustomerId"
          value={values.defaultCustomerId}
          error={errors.defaultCustomerId}
          onChange={handleInpChg}
          options={customers}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <InputImg
          label="Org. Logo"
          name="logoFile"
          src={values.logo}
          value={values.logoFile}
          rmv={() => {
            setValues({ ...values, logoFile: "", logo: "" });
          }}
          onChange={handleFile}
          error={errors.logoFile}
        />
      </Grid>
    </Grid>
  );
};

export default OrgInfo;
